// extracted by mini-css-extract-plugin
module.exports = {"thumbnailBtn":"page-header_thumbnailBtn__3DMVY","youtubeVideo":"page-header_youtubeVideo__IGG4f"};